import { useState, useCallback } from 'react';

export interface UseAddNoteDialogReturn {
  open: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

/**
 * Custom hook to manage the AddNoteDialog visibility state.
 * Use this hook in parent components to control the dialog.
 */
export function useAddNoteDialog(): UseAddNoteDialogReturn {
  const [open, setOpen] = useState(false);

  const openDialog = useCallback(() => setOpen(true), []);
  const closeDialog = useCallback(() => setOpen(false), []);

  return {
    open,
    openDialog,
    closeDialog,
  };
}
